function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.196 26.41a3.282 3.282 0 0 0 3.282-3.281H8.913a3.282 3.282 0 0 0 3.283 3.282z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.412 21.763h.416L17.763 5.319a8.417 8.417 0 0 0-3.457-1.832v-.969c0-1.168-.945-2.11-2.11-2.11-1.163 0-2.11.945-2.11 2.11v.969a8.442 8.442 0 0 0-6.33 8.174v5.412a.939.939 0 0 1-.937.938 1.877 1.877 0 0 0-1.877 1.876v1.408c0 .258.209.468.47.468z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.572 18.011a.936.936 0 0 1-.936-.938V11.66c0-.596-.063-1.178-.18-1.739L8.98 21.762h13.998a.47.47 0 0 0 .47-.467v-1.408a1.879 1.879 0 0 0-1.877-1.876z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24.947 1.535a1.07 1.07 0 0 0-1.513.026L1.1 24.68a1.07 1.07 0 1 0 1.54 1.487L24.973 3.048a1.07 1.07 0 0 0-.026-1.513z"
}))));

var SvgMuteNoti = function SvgMuteNoti(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMuteNoti, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mute_noti.4ac78442.svg";
export { ForwardRef as ReactComponent };